import apiRoles from '@/api/roles'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  role: null
}

export const mutationTypes = {
  updateRoleStart: '[update role] Update role start',
  updateRoleSuccess: '[update role] Update role success',
  updateRoleFailure: '[update role] Update role failure',

  getRoleStart: '[update role] Get role start',
  getRoleSuccess: '[update role] Get role success',
  getRoleFailure: '[update role] Get role failure'
}

export const actionTypes = {
  updateRole: '[update role] Update role',
  getRole: '[update role] Get role'
}

const mutations = {
  [mutationTypes.updateRoleStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateRoleSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateRoleFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getRoleStart](state) {
    state.isLoading = true
    state.role = null
  },

  [mutationTypes.getRoleSuccess](state, payload) {
    state.role = payload
    state.isLoading = false
  },

  [mutationTypes.getRoleFailure](state, payload) {
    state.error = payload
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateRole](context, {id, roleInput}) {
    context.commit(mutationTypes.updateRoleStart)
    return new Promise(resolve => {
      apiRoles
        .updateRole(id, roleInput)
        .then(response => {
          context.commit(mutationTypes.updateRoleSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateRoleFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getRole](context, {id}) {
    context.commit(mutationTypes.getRoleStart)
    return new Promise(resolve => {
      apiRoles
        .getRole(id)
        .then(response => {
          context.commit(mutationTypes.getRoleSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getRoleFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
